import { useState, useRef, useEffect } from "react";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  icon_normal,
  kirkos_logo_white_yellow,
  car_sign_up,
} from "../assets/images";
// import CustomInput from "./CustomInput";
import Progressbar from "./Progressbar";
import { useForm } from "react-hook-form";
// import rules from "../rules";
import { useMutation } from "@tanstack/react-query";
import { trackEvent } from "../services/events";
import ReactPixel from "react-facebook-pixel";
import TagManager from "react-gtm-module";
import axiosInstance from "../services/axios.instance";
import { API_URL } from "../services/apiConfig";
import { UserData, VerifyOtp } from "../types";
import "./otp.css";
import "../Pages/Customer/authFlow.css";
import { useLocation, useNavigate, Link } from "react-router-dom";

import SuccessModal from "./SuccessModal";
import ErrorModal from "./ErrorModal";
import { SUCCESS_MESSAGES, ERROR_MESSAGES } from "../utils/messages";
import DraggableWhatsAppIcon from "./CustomerDashBoard/DraggableWhatsAppIcon";
const OtpScreen = () => {
  // const [showOtpscreen, setShowOtpscreen] = useState<boolean>(false);
  const [otp, setOtp] = useState<any>(["", "", "", ""]);
  const [otpRefs] = useState<any>([useRef(), useRef(), useRef(), useRef()]);
  const [isOtpVerified, setIsOtpVerified] = useState<boolean>(false);
  const { state } = useLocation();
  const phoneNum = state && state.phoneNum;
  const [transactionId, setTransactionId] = useState(sessionStorage.getItem("transactionId"));

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);
  const [visibleIndices, setVisibleIndices] = useState<number[]>([]);

  useEffect(() => {
    let interval: any;
    if (resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    } else if (resendTimer === 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [resendTimer]);

  // Auto-focus first OTP input on page load
  useEffect(() => {
    if (otpRefs[0].current) {
      otpRefs[0].current.focus();
    }
    // Page view tracking
    trackEvent({ event_name: "Kirkos_OTP_Page_View", event_category: "Page_View", module: "Registration", payload: { phone: phoneNum } }).catch(() => { });
    if (process.env.REACT_APP_META_PIXEL_ID) {
      try { ReactPixel.track("ViewContent", { content_name: "OTP Verification", content_category: "SignUp" }); } catch (_) { }
    }
  }, []);

  const navigate = useNavigate();
  const handleOtpChange = (index: number, e: any) => {
    const val = e.target.value;

    // Only allow numeric input
    if (val && !/^\d+$/.test(val)) return;

    const newOtp = [...otp];
    // Use the last character to handle overwriting or multiple chars
    const char = val ? val.slice(-1) : "";
    newOtp[index] = char;
    setOtp(newOtp);

    if (char) {
      setVisibleIndices((prev) => [...prev, index]);
      setTimeout(() => {
        setVisibleIndices((prev) => prev.filter((i) => i !== index));
      }, 300);

      // Move to next input if we just entered a digit
      if (index < otpRefs.length - 1) {
        otpRefs[index + 1].current.focus();
      }
    }
  };

  const handleOtpKeyDown = (index: number, e: any) => {
    if (e.key === "Backspace") {
      if (!otp[index] && index > 0) {
        // If current field is empty, move focus to the previous field
        otpRefs[index - 1].current.focus();
      }
      // If the field has a value, the browser will naturally clear it, 
      // and handleOtpChange will be triggered.
    }
  };

  const {
    // control,
    handleSubmit,
    formState: { isValid },
    // setValue,
    // trigger,
  } = useForm({ mode: "onChange" });
  const handleOtpVerify = () => {
    const otpValue = otp.join("");
    if (otpValue.length < 4) {
      toast.error("Please enter the complete 4-digit verification code");
      return;
    }
    trackEvent({ event_name: "Kirkos_OTP_Verify_Attempt", event_category: "SignUp", module: "Registration", payload: { otp_length: otpValue.length } }).catch(() => { });
    if (process.env.REACT_APP_META_PIXEL_ID) {
      try { ReactPixel.track("InitiateCheckout", { content_name: "OTP Verify", content_category: "SignUp" }); } catch (_) { }
    }
    const payLoad: VerifyOtp = {
      phoneNo: phoneNum,
      transactionId,
      otp: otpValue,
      userType: "CONSUMER",
      event: "register",
    };
    verifyOtp.mutate(payLoad);
  };
  const verifyOtp = useMutation({
    mutationFn: (userData: VerifyOtp) =>
      axiosInstance.post(API_URL.VERIFY_OTP, userData),
    onSuccess: async (successResponse) => {
      if (!(window as any).fbq && process.env.REACT_APP_META_PIXEL_ID) {
        ReactPixel.init(process.env.REACT_APP_META_PIXEL_ID);
      }
      ReactPixel.track("Registration", {
        content_type: "otp_verification",
        content_name: "OTP Verified",
        content_category: "SignUp",
        status: "success",
      });
      TagManager.dataLayer({
        dataLayer: {
          event: "signup_complete",
          page_type: "standard",
          page_path: window.location.pathname,
          page_url: window.location.href,
          phone_number: phoneNum
        }
      });
      await trackEvent({
        event_name: { web: "Kirkos_OTP_Verify_Success", app: "Kirkos_OTP_Verify_Success_App" },
        event_category: "SignUp",
        module: "Registration",
        payload: {
          status: "success",
          message: successResponse?.data?.message ?? "",
        },
      });



      console.log("successResponseOtp", successResponse);
      if (successResponse.status && successResponse?.data?.message) {
        setIsOtpVerified(true);
        navigate("./signupdetails", { state: { phoneNum: phoneNum } });
        // setShowSuccessModal(true);
      }
    },
    onError: async (error: any) => {
      if (!(window as any).fbq && process.env.REACT_APP_META_PIXEL_ID) {
        ReactPixel.init(process.env.REACT_APP_META_PIXEL_ID);
      }
      ReactPixel.track("Registration", {
        content_type: "otp_failed",
        content_name: "OTP Verification Failed",
        content_category: "SignUp",
        status: "failed",
      });
      await trackEvent({
        event_name: { web: "Kirkos_OTP_VerifyFailed", app: "Kirkos_OTP_VerifyFailed_App" },
        event_category: "SignUp",
        module: "Registration",
        payload: {
          status: "failed",
          message: error?.data?.message ?? error?.message ?? "Unknown error",
        },
      });

      if (error?.data?.message) {
        // alert(error?.data?.message);
        setShowErrorModal(true);
      }
    },
  });
  const handleResendOtp = () => {
    if (resendTimer > 0) return;

    trackEvent({ event_name: "Kirkos_OTP_Resend_Click", event_category: "SignUp", module: "Registration", payload: { phone: phoneNum } }).catch(() => { });
    if (process.env.REACT_APP_META_PIXEL_ID) {
      try { ReactPixel.track("OTPResend", { content_category: "SignUp" }); } catch (_) { }
    }

    const userData: UserData = {
      phoneNo: phoneNum,
      userType: "CONSUMER",
      event: "register",
    };

    resendOtp.mutate(userData);
    setResendTimer(30);
  };

  // const goBackward = () => {
  //   navigate("signup");
  // };

  const resendOtp = useMutation({
    mutationFn: (userData: UserData) =>
      axiosInstance.post(API_URL.SEND_OTP, userData),
    onSuccess: (successResponse) => {
      if (successResponse.data && successResponse.data.transactionId) {
        const newTransactionId = successResponse.data.transactionId;
        setTransactionId(newTransactionId);
        sessionStorage.setItem("transactionId", newTransactionId);
        console.log("New Transaction ID:", newTransactionId);
      }
      console.log("successResponseResendOtp", successResponse);
      if (successResponse.status && successResponse?.data?.message) {
        // setShowSuccessModal(true);
      }
    },
    onError: (error: any) => {
      if (error?.data?.message) {
        setShowErrorModal(true);
      }
    },
  });
  return (
    <div className="customer-auth-page">
      <div className="customer-auth-shell">
        <div className="customer-auth-brand-panel">
          <div className="customer-auth-brand-topbar">
            <Link to="/" className="customer-auth-logo-link" aria-label="Kirkos home">
              <img
                src={kirkos_logo_white_yellow}
                alt="Kirkos"
                className="customer-auth-logo"
              />
            </Link>
            <div className="customer-auth-brand-links">
              <Link to="/" className="customer-auth-brand-link">
                Home
              </Link>
              <Link to="/signin" className="customer-auth-brand-link">
                Login
              </Link>
            </div>
          </div>

          <div className="customer-auth-brand-content">
            <div>
              <span className="customer-auth-eyebrow">Verification step</span>
              <h1 className="customer-auth-brand-title">
                Confirm your number and keep the onboarding moving.
              </h1>
              <p className="customer-auth-brand-copy">
                Your mobile verification protects the Kirkos account journey and
                keeps booking access tied to the right customer profile.
              </p>
            </div>

            <div className="customer-auth-brand-highlights">
              <div className="customer-auth-highlight-card">
                <span className="customer-auth-highlight-value">Step 2</span>
                <span className="customer-auth-highlight-label">
                  OTP confirmation before personal details
                </span>
              </div>
              <div className="customer-auth-highlight-card">
                <span className="customer-auth-highlight-value">Secure</span>
                <span className="customer-auth-highlight-label">
                  Protected access for your upcoming account
                </span>
              </div>
              <div className="customer-auth-highlight-card">
                <span className="customer-auth-highlight-value">SMS</span>
                <span className="customer-auth-highlight-label">
                  Quick verification on your registered number
                </span>
              </div>
            </div>

            <div className="customer-auth-car-stage">
              <div className="customer-auth-car-glow" />
              <img
                src={car_sign_up}
                className="customer-auth-car-image"
                alt="Kirkos verification stage"
              />
            </div>
          </div>
        </div>

        <div className="customer-auth-card">
          <div className="customer-auth-card-head">
            <div className="customer-auth-progress">
              <Progressbar currentStage={2} />
            </div>
            <div className="customer-auth-card-icon-wrap">
              <img
                src={icon_normal}
                className="customer-auth-card-icon"
                alt="OTP verification"
              />
            </div>
            <span className="customer-auth-card-kicker">OTP verification</span>
            <h2 className="customer-auth-heading">Enter the code</h2>
            <p className="customer-auth-subcopy">
              We have sent a one-time password to <strong>+971 {phoneNum}</strong>.
              Enter the code below to continue.
            </p>
            <div className="customer-auth-links-row">
              <span className="customer-auth-links-label">Incorrect number?</span>
              <Link to="/signup" className="customer-auth-inline-link">
                Change number
              </Link>
            </div>
          </div>

          <div className="customer-auth-scroll-area">
            <div className="customer-auth-field-block">
              <label className="customer-auth-label">Verification code</label>
              <div className="customer-auth-otp-grid">
                {[0, 1, 2, 3].map((index) => (
                  <input
                    key={index}
                    type={visibleIndices.includes(index) ? "text" : "password"}
                    inputMode="numeric"
                    className="customer-auth-otp-box"
                    placeholder="0"
                    maxLength={1}
                    value={otp[index]}
                    onChange={(e) => handleOtpChange(index, e)}
                    onKeyDown={(e) => handleOtpKeyDown(index, e)}
                    onFocus={(e) => e.target.select()}
                    ref={otpRefs[index]}
                  />
                ))}
              </div>
            </div>

            <button
              className="customer-auth-button-primary"
              onClick={handleOtpVerify}
            >
              Verify OTP
            </button>

            <div className="customer-auth-utility-row">
              <span className="customer-auth-utility-copy">
                Didn&apos;t receive the code?
              </span>
              {resendTimer > 0 ? (
                <span className="customer-auth-secondary-link">
                  Resend in {resendTimer}s
                </span>
              ) : (
                <a className="customer-auth-secondary-link" onClick={handleResendOtp}>
                  Resend SMS
                </a>
              )}
            </div>

            <div className="customer-auth-bottom-support">
              <span className="customer-auth-support-tag">Verification note</span>
              <p className="customer-auth-support-msg">
                Once the OTP is confirmed, we will take you straight to the
                final account setup step.
              </p>
            </div>
          </div>
        </div>
      </div>
      <SuccessModal
        isOpen={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        onNav={() => {
          if (verifyOtp.isSuccess) {
            navigate("./signupdetails", { state: { phoneNum: phoneNum } });
          } else {
            setShowSuccessModal(false);
          }
        }}
        message={
          verifyOtp.isSuccess
            ? SUCCESS_MESSAGES.OTP_VERIFIED
            : SUCCESS_MESSAGES.OTP_RESENT
        }
      />
      <ErrorModal
        isOpen={showErrorModal}
        onClose={() => setShowErrorModal(false)}
        message={
          verifyOtp.isError ? (verifyOtp.error as any)?.data?.message || ERROR_MESSAGES.OTP_VERIFY_FAILED : ERROR_MESSAGES.OTP_RESEND_FAILED
        }
      />
      <DraggableWhatsAppIcon />
    </div>
  );
};

export default OtpScreen;
